import { Transform, Type } from "class-transformer";
import { parseApiDate } from "@/utils/dates/dateFormats";
import { toEuros } from "@/utils/numberUtils";
import { ExecutionReportProjectDto } from "@/core/features/valuations/execution-report-project.dto";

export class ExecutionReportRowDto {
  id: string;
  type: "valuation" | "certification";
  dossierId: string;
  dossierCode?: string;
  dossierDescription?: string;

  @Transform(({ value }) => (value ? parseApiDate(value) : null))
  startDate?: Date;

  @Transform(({ value }) => (value ? parseApiDate(value) : null))
  endDate?: Date;

  @Transform(({ value }) => toEuros(value, false))
  amount: number;

  code?: string;
  status?: string;
  certificationStatus?: string;
  certificationId?: string;
  responsibleUserId?: string;

  @Transform(({ value }) => (value ? parseApiDate(value) : null))
  registrationDate?: Date;

  contactPerson?: string;

  @Transform(({ value }) => (value ? parseApiDate(value) : null))
  certificationSentDate?: Date;

  @Transform(({ value }) => (value ? parseApiDate(value) : null))
  otReportSentDate?: Date;

  otQuantity?: number;

  @Transform(({ value }) => (value ? parseApiDate(value) : null))
  clientApprovalDate?: Date;

  @Transform(({ value }) => (value ? parseApiDate(value) : null))
  movedToBillingDate?: Date;

  @Transform(({ value }) =>
    Array.isArray(value) ? value.map((deliveryDate) => parseApiDate(deliveryDate)).filter(Boolean) : []
  )
  deliveryDates?: Date[];

  clientGroupId?: string;
  clientGroupName?: string;

  @Type(() => ExecutionReportProjectDto)
  projects?: ExecutionReportProjectDto[];

  projectCodes?: string;
  scopes?: string;
  operativeUnitCodes?: string;
  workplaceNames?: string;
  zoneNames?: string;
  interventionNames?: string;
  interventionCodes?: string;
  offerCodes?: string;
  orderNumbers?: string;
  clientTypeName?: string;
  clientSapCode?: string;
  clientName?: string;
  projectStatusLabels?: string;
  displayStatus?: string;
  displayStatusType?: "valuation" | "certification";
  comments?: string;
}
